export const orgHostGetter = (rootDomain) => (org) => {
  return (org.domain || `${ org.sub }.${ rootDomain }`).toLowerCase();
};

export const isMatchedByHost = (host) => (org) => {
  const parts = host.split('.');
  let hostRootDomain;
  if (parts.length === 2) {
    hostRootDomain = host;
  } else {
    parts.shift();
    hostRootDomain = parts.join('.');
  }
  return host.toLowerCase().includes(orgHostGetter(hostRootDomain)(org));
};

export const isMatchedById = (matchedId) => (org) => {
  return org.globalId === matchedId;
};

export const isOwnedByUserPredicate = (userId) => (org) => {
  return org.userId === userId;
};

export const isDefaultOrgPredicate = (userId) => (org) => {
  return org.globalId === `u${ userId.toString(36) }`;
};

export const isB2BOrgPredicate = () => (org) => {
  return org.orgType === 'business';
};

export const isOrgSubscription = subscription => ({ subscriptionType }) =>
  subscriptionType === subscription;

export const isB2COrgPredicate = () => (org) => {
  return org.orgType === 'private' || !isB2BOrgPredicate();
};

export const isCnameEnabledPredicate = () => (org) => {
  return !!org.domain;
}
